module.exports = __webpack_public_path__ + "static/media/builtsmart-promo.00ef4500.webp";